"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      isLoading: false,
      pageName: "productTag",
      searchQuery: {
        materialCode: "",
        materialDescription: "",
        vehicleType: "",
        pattern: "",
        yearOfNew: null
      },
      apiModule: "kpiSet"
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0)"
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  computed: {
    domData: function domData() {
      return {
        materialCode: {
          label: this.$t("sfe.productTag.materialCode"),
          valueKey: "materialCode"
        },
        materialDescription: {
          label: this.$t("sfe.productTag.materialDescription"),
          valueKey: "materialDescription"
        },
        vehicleType: {
          label: this.$t("sfe.productTag.vehicleType"),
          valueKey: "vehicleType",
          inputType: "select",
          options: [{
            label: "SUV",
            value: "SUV"
          }, {
            label: "LUX",
            value: "LUX"
          }, {
            label: "EV",
            value: "EV"
          }, {
            label: "New Product",
            value: "NEW"
          }],
          optionLabel: "label",
          optionValue: "value"
        },
        pattern: {
          label: this.$t("sfe.productTag.pattern"),
          valueKey: "pattern",
          inputType: "select",
          options: [{
            label: "AMG",
            value: "AMG"
          }, {
            label: "RT",
            value: "RT"
          }, {
            label: "ED",
            value: "ED"
          }, {
            label: "ACT",
            value: "ACT"
          }],
          optionLabel: "label",
          optionValue: "value"
        },
        yearOfNew: {
          label: this.$t("sfe.productTag.yearOfNew"),
          valueKey: "yearOfNew",
          inputType: "date",
          type: "year"
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t("sfe.route.producttag"),
          apiUrl: "/protected/productRefVehicle/export"
        },
        import: {
          apiUrl: "/protected/productRefVehicle/import"
        }
      };
    },
    tableDom: function tableDom() {
      return {
        materialCode: {
          label: this.$t("sfe.productTag.materialCode")
        },
        materialDescription: {
          minWidth: 300,
          label: this.$t("sfe.productTag.materialDescription")
        },
        vehicleTypeSuv: {
          minWidth: 80,
          label: this.$t("sfe.productTag.vehicleTypeSuv")
        },
        vehicleTypeLux: {
          minWidth: 80,
          label: this.$t("sfe.productTag.vehicleTypeLux")
        },
        vehicleTypeEv: {
          minWidth: 80,
          label: this.$t("sfe.productTag.vehicleTypeEv")
        },
        vehicleTypeNew: {
          minWidth: 80,
          label: this.$t("sfe.productTag.vehicleTypeNew")
        },
        yearOfNew: {
          minWidth: 80,
          label: this.$t("sfe.productTag.yearOfNew")
        },
        // patternAmg: {
        //   minWidth: 80,
        //   label: this.$t('sfe.productTag.patternAmg')
        // },
        // patternRt: {
        //   minWidth: 80,
        //   label: this.$t('sfe.productTag.patternRt')
        // },
        // patternEd: {
        //   minWidth: 80,
        //   label: this.$t('sfe.productTag.patternEd')
        // },
        // patternAct: {
        //   minWidth: 80,
        //   label: this.$t('sfe.productTag.patternAct')
        // },
        pattern: {
          minWidth: 80,
          label: this.$t("sfe.productTag.pattern")
        },
        productIntegral: {
          minWidth: 80,
          label: this.$t("sfe.productTag.productIntegral")
        },
        fixedCost: {
          minWidth: 80,
          label: this.$t("sfe.productTag.fixedCost")
        },
        variableCost: {
          minWidth: 80,
          label: this.$t("sfe.productTag.variableCost")
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: "/protected/productRefVehicle/list"
      };
    }
  },
  methods: {
    downloadExcel: function downloadExcel() {
      var _this = this;
      if (this.isLoading) return;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      var apiModule = this.tableButtons["export"]["apiModule"] || this.apiModule;
      var promiseFn = this.$api[apiModule]["exportKpiFile"];
      var fileName = this.$t("sfe.productTag.productInfoFileName");
      promiseFn("/protected/productInfo/exportProductInfo", param, "").then(function (res) {
        _this.isLoading = false;
        (0, _index.downloadFileExcel)(fileName, res.data);
      }).catch(function () {
        _this.isLoading = false;
      });
    }
  }
};